/**
 * @file _initialize/_accordion.js
 */
(function ($) {
	'use strict';
		var ApplyClass = require('../_util/_apply-class');
		var Accordion = require('../_view/_accordion');

	/**
	 * recruit formのaccordion 初期化
	 * @return {undefined}
	 */


	var AccordionInitialize = function () {
		$(function () {
			applyClass();
		});
	};

	/**
	 * Recruit Form の各項目をアコーディオンさせる
	 */
	var applyClass = function (idx, e) {
		$('.dl-accordion').each(function() {
			var $e = $(e);
			ApplyClass.apply(Accordion, $e);
		});
	};

	module.exports = AccordionInitialize;
})(jQuery);
